import { PasswordReset } from '~/authentication/types';
import type { RequestInterface } from '~/common/types';
import { UserRegisterRequest } from '~/users/types';

export class LoginRequest implements RequestInterface {
  method = 'post';
  path = '/api/v1/login';
  data: Record<string, any>;

  constructor(username: string, password: string) {
    this.data = {
      username,
      password,
    };
  }
}

export class LogoutRequest implements RequestInterface {
  method = 'delete';
  path = '/api/v1/logout';
  headers: Record<string, any>;

  constructor(token: string) {
    this.headers = {
      authorization: `Bearer ${token}`,
    };
  }
}

export class RegisterUserRequest implements RequestInterface {
  method = 'post';
  path = '/api/v1/register';
  data: Record<string, any>;

  constructor(user: UserRegisterRequest) {
    this.data = user;
  }
}

export class ForgotPasswordRequest implements RequestInterface {
  method = 'post';
  path = '/api/v1/password/forgot';
  data: Record<string, any>;

  constructor(username: string) {
    this.data = {
      username,
    };
  }
}

export class ResetPasswordRequest implements RequestInterface {
  method = 'post';
  path = '/api/v1/password/reset';
  data: Record<string, any>;

  constructor(args: PasswordReset) {
    this.data = {
      ...args,
    };
  }
}

export class oktaLogin implements RequestInterface {
  method = 'post';
  path = '/login/okta';
  data: Record<string, any>;

  constructor(email: string) {
    this.data = {
      email,
    };
  }
}
